/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCakeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-cake"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.4 22.85Q2.9 22.85 2.55 22.52Q2.2 22.2 2.2 21.7L2.2 18.05Q2.2 16.93 2.96 16.16Q3.73 15.4 4.85 15.4L19.15 15.4Q20.27 15.4 21.04 16.16Q21.8 16.93 21.8 18.05L21.8 21.7Q21.8 22.18 21.46 22.51Q21.13 22.85 20.65 22.85ZM4.85 12.75L4.85 10.6Q4.85 9.47 5.61 8.71Q6.38 7.95 7.5 7.95L10.65 7.95L10.65 6.45Q10.15 6.1 9.9 5.64Q9.65 5.17 9.65 4.5Q9.65 4.05 9.81 3.66Q9.97 3.27 10.35 2.9L11.53 1.73Q11.57 1.68 12 1.52Q12.07 1.52 12.47 1.73L13.65 2.9Q14.03 3.27 14.19 3.66Q14.35 4.05 14.35 4.5Q14.35 5.17 14.1 5.64Q13.85 6.1 13.35 6.45L13.35 7.95L16.5 7.95Q17.63 7.95 18.39 8.71Q19.15 9.47 19.15 10.6L19.15 12.75Z" fill={color} />
    </svg>
  );
}
